import { _t } from "@cruisen/i18n"
import { TripSearchResultDeck } from "@cruisen/contract"
import { CruiseSearchResult } from "../types"

export const cruiseSortingKeys = {
  date: "date",
  durationShortToLong: "durationShortToLong",
  durationLongToShort: "durationLongToShort",
  mostLikes: "mostLiked",
  priceLowToHigh: "priceLowToHigh",
  priceHighToLow: "priceHighToLow",
}

export const getSortingOptions = () => [
  { label: _t("tripOverview.sortingLabels.mostLiked"), id: cruiseSortingKeys.mostLikes },
  { label: _t("tripOverview.sortingLabels.date"), id: cruiseSortingKeys.date },
  {
    label: _t("tripOverview.sortingLabels.durationShortToLong"),
    id: cruiseSortingKeys.durationShortToLong,
  },
  {
    label: _t("tripOverview.sortingLabels.durationLongToShort"),
    id: cruiseSortingKeys.durationLongToShort,
  },
  { label: _t("tripOverview.sortingLabels.priceByLowest"), id: cruiseSortingKeys.priceLowToHigh },
  { label: _t("tripOverview.sortingLabels.priceByHighest"), id: cruiseSortingKeys.priceHighToLow },
]

export const sortCruises = ({
  cruises,
  sortBy,
  sortByLikesOrder,
}: {
  cruises: CruiseSearchResult[]
  sortByLikesOrder: Map<string, number>
  sortBy: string
}) => {
  switch (sortBy) {
    case cruiseSortingKeys.date:
      return [...cruises].sort((a, b) => (a.startDate.getTime() > b.startDate.getTime() ? 1 : -1))
    case cruiseSortingKeys.durationShortToLong:
      return [...cruises].sort((a, b) =>
        a.startDate.getTime() - a.endDate.getTime() > b.startDate.getTime() - b.endDate.getTime()
          ? -1
          : 1,
      )
    case cruiseSortingKeys.durationLongToShort:
      return [...cruises].sort((a, b) =>
        a.startDate.getTime() - a.endDate.getTime() > b.startDate.getTime() - b.endDate.getTime()
          ? 1
          : -1,
      )
    case cruiseSortingKeys.mostLikes:
      return [...cruises].sort(
        (a, b) => (sortByLikesOrder.get(a.id) || 0) - (sortByLikesOrder.get(b.id) || 0),
      )
    case cruiseSortingKeys.priceLowToHigh:
      return [...cruises].sort((a, b) => (a.pricePP.price > b.pricePP.price ? 1 : -1))
    case cruiseSortingKeys.priceHighToLow:
      return [...cruises].sort((a, b) => (a.pricePP.price > b.pricePP.price ? -1 : 1))
    default:
      return cruises
  }
}

const collator = new Intl.Collator([], {
  usage: "sort",
  numeric: true,
  sensitivity: "accent",
})

export const sortDecks = (decks: TripSearchResultDeck[] = []) => {
  decks.sort((a, b) => collator.compare(a.sorting, b.sorting))
  return decks
}
